/**
 * Extracts the domain from an email address
 * @param email - Email address (e.g., "user@example.com")
 * @returns Domain (e.g., "example.com") or null if invalid
 */
export const extractDomainFromEmail = (email: string | undefined | null): string | null => {
  if (!email) {
    return null;
  }

  const parts = email.split('@');
  if (parts.length !== 2) {
    return null;
  }

  const domain = parts[1].toLowerCase().trim();
  return domain || null;
};
